import { post, put, get, c_post } from "@/common/authentication/API";
import store from "@/store/store";

export async function submitLogin(username: string, password: string) {
  const data = {
    username: username,
    password: password,
  };
  return await post(
    "https://crescent-backend-v2.herokuapp.com/login",
    data,
    {}
  );
}
export async function submitRegister(
  username: string,
  password: string,
  email: string
) {
  const data = {
    username: username,
    email: email,
    password: password,
  };
  return await c_post(
    "https://crescent-backend-v2.herokuapp.com/register",
    data
  );
}

export function isLoggedIn() {
  const token = store.state.authToken;
  return !!(token && token !== "");
}
export async function addEmail(username: string, email: string) {
  const config = {
    headers: {
      AUTH_TOKEN:
        "WCmxrkzQzEJUM9Dfi5ch0fVK3nVAE0uBiDANFMqRFL4Ym-cN0FvAWqn_94EUXSRDRlygP7C0IjZw0Kl2JzQhEw",
    },
  };
  const data = {
    username: username,
    email: email,
  };
  const url = "https://crescent-backend-v2.herokuapp.com/auth/addemail";
  return put(url, data, config);
}

export async function changePassword(user_id: string, newPassword: string) {
  const config = {
    headers: {
      AUTH_TOKEN:
        "WCmxrkzQzEJUM9Dfi5ch0fVK3nVAE0uBiDANFMqRFL4Ym-cN0FvAWqn_94EUXSRDRlygP7C0IjZw0Kl2JzQhEw",
    },
  };
  const data = {
    user_id: user_id,
    password: newPassword,
  };

  const url = "https://crescent-backend-v2.herokuapp.com/auth/pass";
  return put(url, data, config);
}

export async function getEmail(username: string) {
  const config = {
    headers: {
      AUTH_TOKEN:
        "WCmxrkzQzEJUM9Dfi5ch0fVK3nVAE0uBiDANFMqRFL4Ym-cN0FvAWqn_94EUXSRDRlygP7C0IjZw0Kl2JzQhEw",
    },
  };

  const url = `https://crescent-backend-v2.herokuapp.com/auth/addemail?username=${username}`;

  return get(url, config);
}

export function setToken(token: string) {
  localStorage.setItem("CrescentToken", token);
  store.commit("setAuthToken", token);
}

export function deleteToken() {
  localStorage.removeItem("CrescentToken");
  store.commit("setAuthToken", "");
}
export function getToken() {
  const token = localStorage.getItem("CrescentToken");
  // Token can be undefined if it is not in the store
  if (token) {
    store.commit("setAuthToken", token);
  }
  return token;
}
